// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:700px){.gala-btn[data-v-8d897fd4]{font-size:16px}}.user-email[data-v-8d897fd4]{word-break:break-word}.sent-message[data-v-8d897fd4]{max-width:400px}", ""]);
// Exports
module.exports = exports;
